module.exports = {
      id: "sports-usage",
      viewBox: "0 0 26.459 26.453",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#sports",
      toString: function () {
        return this.url;
      }
    }